import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { useCallback } from 'react';
import { useCommerceFetch } from '@atlassian/commerce-environment';
import { get, isError, isSuccessful } from '@atlassian/commerce-hams-client';
import { FAILED_SITE_KEY_RETRIEVAL } from '@atlassian/commerce-recaptcha-base';
import { ProbabilityOfBug, Service, useTaskTracker } from '@atlassian/commerce-telemetry';
import { DEFAULT_HAMS_RECAPTCHA_BASE_URL } from './constants';
export var useHAMSRequestSiteKey = function useHAMSRequestSiteKey(operation) {
  var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_HAMS_RECAPTCHA_BASE_URL;
  var fetch = useCommerceFetch();
  /*
    TODO: We're probably never going to register the track events for "loading" tasks so
    maybe we should make a version of this method called useLoadTracker or something since they
    have different telemetry requirements.
  */

  var startTask = useTaskTracker({
    action: 'load',
    actionSubject: 'hamsReCaptchaSiteKey'
  });
  var fetchSiteKey = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var taskResult, successResult;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return startTask( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var payload, isInternalHAMSError;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return get(fetch, "".concat(baseUrl, "/").concat(operation));

                    case 2:
                      payload = _context.sent;

                      if (!isSuccessful(payload)) {
                        _context.next = 7;
                        break;
                      }

                      return _context.abrupt("return", {
                        succeed: {
                          payload: payload
                        }
                      });

                    case 7:
                      isInternalHAMSError = isError(payload) && payload.error.status >= 500 && payload.error.status <= 599 ? Service.HAMS : undefined;
                      return _context.abrupt("return", {
                        fail: {
                          payload: payload,
                          // There's no non-buggy error for this endpoint, something's going wrong somewhere
                          probabilityOfBug: ProbabilityOfBug.GUARANTEED,
                          responsibleService: isInternalHAMSError ? Service.HAMS : undefined,
                          loggablePayload: isError(payload) ? payload.error : payload.exception
                        }
                      });

                    case 9:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            })));

          case 2:
            taskResult = _context2.sent;

            if (!(taskResult.fail !== undefined)) {
              _context2.next = 7;
              break;
            }

            return _context2.abrupt("return", FAILED_SITE_KEY_RETRIEVAL);

          case 7:
            successResult = taskResult.succeed.payload;

            if (!(successResult.payload === null)) {
              _context2.next = 12;
              break;
            }

            return _context2.abrupt("return", {
              failed: false,
              siteKey: null
            });

          case 12:
            return _context2.abrupt("return", {
              failed: false,
              siteKey: successResult.payload.siteKey
            });

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [fetch, operation, baseUrl, startTask]);
  return fetchSiteKey;
};